export default __webpack_public_path__ + "static/media/iphone13-bg.48259e5c.webp";